import React from 'react';
import { GraphQLLoader } from '../../../../.starryUI/Loading/GraphQLLoader';
import { IAppContextQueryResult, useAppContextQuery } from '../graphql/useAppContextQuery';

const AppContext = React.createContext<IAppContextQueryResult>({
    security: {
        entry: {
            canView: false,
            field: {
                iD1: {
                    canView: false,
                },
                iD2: {
                    canView: false,
                },
                iD3: {
                    canView: false,
                },
                iD4: {
                    canView: false,
                },
                iD5: {
                    canView: false,
                },
            },
            filter: {
                allEntries: {
                    canView: false,
                },
                activeEntries: {
                    canView: false,
                },
                canUpdateFilters: false,
                canManageSavedList: false,
            },
        },
    },

    global: {
        setting: {
            iD1Label: '',
            iD2Label: '',
            iD3Label: '',
            iD4Label: '',
            iD5Label: '',
        },
    },
});

export const useAppContext = () => React.useContext<IAppContextQueryResult>(AppContext);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
    const { data, loading, error } = useAppContextQuery();

    return (
        <GraphQLLoader error={error} loading={loading}>
            {() => <AppContext.Provider value={{ ...data! }}>{children}</AppContext.Provider>}
        </GraphQLLoader>
    );
};
